import React from 'react';
import {view, Divider} from '@sail/ui';
import {useIntl} from '@sail/intl';
import {Skeleton} from '../../SharedComponents/Skeleton';
import {messages} from './messages';
import {styles} from './styles';

export const UploadedFileLoadingState = ({
  fileName,
  showDivider,
  showPreview,
}: {
  fileName: string | null | undefined;
  showDivider: boolean;
  showPreview?: boolean;
}) => {
  const intl = useIntl();

  return (
    <>
      <view.div uses={[styles.fileContainerRowStyles]}>
        {showPreview && (
          <Skeleton
            styles={[
              styles.filePreviewStyles,
              styles.filePreviewStylesUnprocessed,
            ]}
          />
        )}
        <view.div uses={[styles.fileContainerColumnStyles]}>
          <view.div uses={[styles.fileNameContainerStyles]}>
            <view.span
              uses={[styles.fileNameStyles, styles.fileNameStylesUnprocessed]}
            >
              {fileName || intl.formatMessage(messages.uploadedFilePlaceholder)}
            </view.span>
          </view.div>

          <Skeleton height="24px" fillWidth />
        </view.div>
      </view.div>
      {showDivider && <Divider uses={[styles.dividerStyles]} />}
    </>
  );
};
